module.exports = __webpack_public_path__ + "static/media/credit_card.fd09b306.svg";